import { AxiosResponse } from "axios";
import {
  AssignCategoryPayload,
  PaginatedUnitSizes,
  UnitSize,
  UnitSizePayload,
  UnitSizeRead,
} from "@types";
import { request } from "@utils";

export const getAllUnitSizes = async (
  page?: number,
  withPagination: boolean = true,
): Promise<AxiosResponse<PaginatedUnitSizes>> => {
  const req = request();

  if (withPagination) {
    return req.get<PaginatedUnitSizes>(
      `/api/v1/sizes/paginated?page=${page ?? 1}&limit=10`,
    );
  }

  const res = await req.get<UnitSizeRead[]>(`/api/v1/sizes`);
  return {
    ...res,
    data: {
      data: res.data,
      totalCount: res.data.length,
      totalPages: 1,
    },
  };
};

export const createUnitSize = async (data: UnitSize): Promise<UnitSizeRead> => {
  const res = await request().post("/api/v1/sizes", data);
  return res.data;
};

export const updateUnitSize = async (
  id: string,
  data: UnitSizePayload,
): Promise<UnitSizeRead> => {
  const res = await request().put(`/api/v1/sizes/${id}`, data);
  return res.data;
};

export const deleteUnitSize = async (id: string): Promise<UnitSizeRead> => {
  const res = await request().delete(`/api/v1/sizes/${id}`);
  return res.data;
};

export const uploadUnitSizeImage = async (
  id: string,
  file: File,
): Promise<UnitSizeRead> => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await request().post(`/api/v1/upload/size/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export const assignCategoryToSizes = async (
  data: AssignCategoryPayload,
): Promise<UnitSizeRead[]> => {
  const res = await request().put(`/api/v1/sizes/assignCategory`, data);
  return res.data;
};

export const getSizesByCategory = (
  unitCategoryId: string,
  page: number = 1,
  limit?: number,
): Promise<AxiosResponse<PaginatedUnitSizes>> => {
  const req = request();

  if (limit === undefined) {
    return req.get(`/api/v1/sizes/unitCategory/${unitCategoryId}`);
  }

  return req.get(
    `/api/v1/sizes/unitCategory/${unitCategoryId}?page=1?limit=10`,
  );
};
